(()=>{
 if(window.tosBilboScare)return;window.tosBilboScare=true;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)'),key='tos-bilbo-scare-seen';
 let seen=false,timer,finishScare=null,activeScare=null;try{seen=sessionStorage.getItem(key)==='1';}catch{}
 if(seen||reduced.matches)return;
 const layer=document.createElement('div');layer.className='tos-bilbo-scare';layer.hidden=true;layer.setAttribute('aria-hidden','true');
 const picture=document.createElement('picture'),source=document.createElement('source'),img=document.createElement('img');
 source.media='(max-width: 749px)';source.srcset='https://cdn.shopify.com/s/files/1/0688/4825/5207/files/Sem_titulofsdfsdf.jpg?v=1789407534';
 img.src='https://cdn.shopify.com/s/files/1/0688/4825/5207/files/499170256_3789671254509507_1818015965695327170_n.jpg?v=1789407534';img.alt='';img.decoding='async';
 picture.append(source,img);layer.append(picture);document.body.append(layer);
 const hide=()=>{layer.hidden=true;clearTimeout(timer);const done=finishScare;finishScare=null;if(done)done();};
 const show=data=>{
  if(!['home-button','product-added'].includes(data.source)||seen||reduced.matches||document.hidden||!img.complete||!img.naturalWidth)return;
  seen=true;try{sessionStorage.setItem(key,'1');}catch{}
  layer.hidden=false;timer=setTimeout(hide,data.source==='product-added'?1500:850);return true;
 };
 // Called on PDP submit; product-form waits for both this effect and cart success.
 window.tosPlayBilboScare=()=>{
  if(!document.querySelector('[data-halloween-effects][data-page="product"]'))return Promise.resolve();
  if(activeScare)return activeScare;
  activeScare=new Promise(resolve=>{finishScare=resolve;if(!show({source:'product-added'})){finishScare=null;resolve();}}).finally(()=>{activeScare=null;});
  return activeScare;
 };
 let navigating=false;
 if(document.querySelector('[data-halloween-effects][data-page="index"]'))document.addEventListener('click',e=>{
  const button=e.target.closest('main a.button,main .collection-list-wrapper a');
  if(!button||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||button.target==='_blank'||button.hasAttribute('download'))return;
  if(!button.matches('a.button')&&!button.textContent.trim().match(/view all/i))return;
  if(navigating){e.preventDefault();return;}
  const href=button.getAttribute('href');if(!href||href.startsWith('#'))return;
  if(!show({source:'home-button'}))return;
  if(button.matches('.tos-halloween__button')){e.tosBilboDelay=850;return;}
  e.preventDefault();navigating=true;setTimeout(()=>location.assign(href),850);
 },true);
 document.addEventListener('visibilitychange',()=>{if(document.hidden)hide();});
 reduced.addEventListener('change',()=>{if(reduced.matches)hide();});
 addEventListener('pagehide',hide);addEventListener('keydown',e=>{if(e.key==='Escape')hide();});
})();
